import React, { useEffect } from "react";
import "../Home.css";
import { Link } from "react-router-dom";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

function Home() {
    useEffect(() => {
      document.title = "Hello, I'm Daniel";
    }, []);
  return (
    <div className="home">
      <div className="background">
        <img src={process.env.PUBLIC_URL + '/images/home/slika.jpg'}/>
      </div>
      <div className="text-container">
        <div className="h1-container">
          <div className="animate__animated animate__fadeInLeft">
            <h1>Hello. I'm Daniel.</h1>
            <h1>Web developer.</h1>
          </div>
        </div>
        <div className="animate__animated animate__fadeInRight">
          <p>
            If you are looking for a web developer, your job ending right now.
            <br />I am not one more average web developer, just the opposite.
          </p>
        </div>
        <div className="animate__animated animate__fadeIn">
          <Link to="portfolio" className="button-link">
            My portfolio <ArrowForwardIcon />
          </Link>
        </div>
      </div>
    </div>
  );
}



export default Home;
